import React from 'react';

import VersionStatus from '../Pills/VersionStatus';

import './ConnectedContentItem.scss';

const ConnectedContentItem = ({ content, hideTextVersion }) => {
  return (
    <>
      <div
        data-testid="selected-content-content"
        className="selected-connected-content"
        key={`connected-content-item-${content.title}-${content.contentId}`}
      >
        <div
          className="selected-content-container"
          data-testid={`selected-content-container-test-${content.contentId}`}
        >
          <p>{content.title}</p>

          <div
            data-testid="version-status"
            className="shared-pill-close-icon-container"
          >
            <VersionStatus
              content={content}
              allowDraftPill={false}
              hideTextVersion={hideTextVersion}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ConnectedContentItem;
